import Svg from '../generated/Views';
import { Icon, type IconProps } from './Icon';

export const ViewsIcon = (props: IconProps) => <Icon component={Svg} name="views" {...props} />;
